export class Language {
    name: string = "";
    displayName: string = "";
    nativeName: string = "";

    constructor(init?: Partial<Language>) {
        if (!init) {
            return;
        }

        Object.assign(this, init);
    }

    toString(): string {
        return this.displayName;
    }
}
